var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#4FAADB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8409 11.84C19.3043 6.71906 10.6934 6.72094 5.15904 11.84C4.95091 12.0325 4.94685 12.3584 5.1481 12.5581L6.2181 13.6197C6.40997 13.8103 6.71872 13.8144 6.9181 13.6316C11.4781 9.45406 18.5212 9.45312 23.0822 13.6316C23.2815 13.8144 23.5903 13.81 23.7822 13.6197L24.8522 12.5581C25.0531 12.3584 25.049 12.0325 24.8409 11.84ZM15 18C13.8953 18 13 18.8953 13 20C13 21.1047 13.8953 22 15 22C16.1047 22 17 21.1047 17 20C17 18.8953 16.1047 18 15 18ZM21.3334 15.3878C17.7315 12.2025 12.2643 12.2059 8.66654 15.3878C8.45091 15.5784 8.44404 15.9094 8.64872 16.1112L9.72497 17.1734C9.91247 17.3584 10.2143 17.3709 10.414 17.1984C13.0375 14.9306 16.9684 14.9356 19.5856 17.1984C19.7853 17.3709 20.0872 17.3587 20.2747 17.1734L21.3509 16.1112C21.5559 15.9094 21.5487 15.5781 21.3334 15.3878Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.13e3ef48aa14f566a713eee7ca263305.svg";
export { ForwardRef as ReactComponent };